// src/components/common/Badge.jsx
import React from 'react';

const Badge = ({ 
  type = 'status', 
  status, 
  condition, 
  category, 
  className = '',
  size = 'medium'
}) => {
  
  const getConfig = () => {
    switch (type) {
      case 'status':
        const statusConfig = {
          active: { 
            label: 'Active', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200'
          },
          sold: { 
            label: 'Sold', 
            color: 'text-red-800', 
            bgColor: 'bg-red-100',
            borderColor: 'border-red-200'
          },
          draft: { 
            label: 'Draft', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          },
          inactive: { 
            label: 'Inactive', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          },
          pending: { 
            label: 'Pending', 
            color: 'text-yellow-800', 
            bgColor: 'bg-yellow-100',
            borderColor: 'border-yellow-200'
          }
        };
        return statusConfig[status] || statusConfig.draft;
      
      case 'condition':
        const conditionConfig = {
          brand_new: { 
            label: 'Brand New', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200'
          },
          like_new: { 
            label: 'Like New', 
            color: 'text-emerald-800', 
            bgColor: 'bg-emerald-100',
            borderColor: 'border-emerald-200'
          },
          fairly_used: { 
            label: 'Fairly Used', 
            color: 'text-amber-800', 
            bgColor: 'bg-amber-100',
            borderColor: 'border-amber-200'
          },
          used: { 
            label: 'Used', 
            color: 'text-yellow-800', 
            bgColor: 'bg-yellow-100',
            borderColor: 'border-yellow-200'
          },
          refurbished: { 
            label: 'Refurbished', 
            color: 'text-purple-800', 
            bgColor: 'bg-purple-100',
            borderColor: 'border-purple-200'
          }
        };
        return conditionConfig[condition] || conditionConfig.used;
      
      case 'category':
        if (!category) return null;
        return {
          label: category,
          color: 'text-indigo-800',
          bgColor: 'bg-indigo-100',
          borderColor: 'border-indigo-200'
        };
      
      case 'orderStatus':
        const orderConfig = {
          pending: { 
            label: 'Pending', 
            color: 'text-yellow-800', 
            bgColor: 'bg-yellow-100',
            borderColor: 'border-yellow-200'
          },
          accepted: { 
            label: 'Accepted', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200'
          },
          processing: { 
            label: 'Processing', 
            color: 'text-blue-800', 
            bgColor: 'bg-blue-100',
            borderColor: 'border-blue-200'
          },
          shipped: { 
            label: 'Shipped', 
            color: 'text-blue-800', 
            bgColor: 'bg-blue-100',
            borderColor: 'border-blue-200'
          },
          delivered: { 
            label: 'Delivered', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200'
          },
          rejected: { 
            label: 'Rejected', 
            color: 'text-red-800', 
            bgColor: 'bg-red-100',
            borderColor: 'border-red-200'
          },
          completed: { 
            label: 'Completed', 
            color: 'text-blue-800', 
            bgColor: 'bg-blue-100',
            borderColor: 'border-blue-200'
          },
          cancelled: { 
            label: 'Cancelled', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          }
        };
        return orderConfig[status] || orderConfig.pending;
      
      case 'moderation':
        if (status === 'approved') return null;
        const moderationConfig = {
          rejected: { 
            label: 'Rejected', 
            color: 'text-red-800', 
            bgColor: 'bg-red-100',
            borderColor: 'border-red-200',
            icon: '❌'
          },
          pending: { 
            label: 'Pending Review', 
            color: 'text-yellow-800', 
            bgColor: 'bg-yellow-100',
            borderColor: 'border-yellow-200',
            icon: '⏳'
          },
          approved: { 
            label: 'Approved', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200',
            icon: '✅'
          }
        };
        return moderationConfig[status] || moderationConfig.pending;
      
      case 'boost':
        const boostConfig = {
          active: { 
            label: 'Active Boost', 
            color: 'text-orange-800', 
            bgColor: 'bg-orange-100',
            borderColor: 'border-orange-200'
          },
          expired: { 
            label: 'Boost Expired', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          },
          none: { 
            label: 'Not Boosted', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          }
        };
        return boostConfig[status] || boostConfig.none;
      
      case 'price':
        const priceConfig = {
          negotiable: { 
            label: 'Negotiable', 
            color: 'text-green-800', 
            bgColor: 'bg-green-100',
            borderColor: 'border-green-200'
          },
          fixed: { 
            label: 'Fixed Price', 
            color: 'text-gray-800', 
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-200'
          }
        };
        return priceConfig[status] || priceConfig.fixed;
      
      case 'featured':
        return {
          label: 'Featured',
          color: 'text-yellow-800',
          bgColor: 'bg-yellow-100',
          borderColor: 'border-yellow-200'
        };
      
      case 'urgent':
        return {
          label: 'Urgent',
          color: 'text-red-800',
          bgColor: 'bg-red-100',
          borderColor: 'border-red-200'
        };
      
      case 'discount':
        return {
          label: 'Discounted',
          color: 'text-pink-800',
          bgColor: 'bg-pink-100',
          borderColor: 'border-pink-200'
        };
      
      default:
        return {
          label: status || 'Unknown',
          color: 'text-gray-800',
          bgColor: 'bg-gray-100',
          borderColor: 'border-gray-200'
        };
    }
  };

  const config = getConfig();
  if (!config) return null;

  const sizeClasses = size === 'small' 
    ? 'px-2 py-0.5 text-xs' 
    : size === 'large' 
      ? 'px-3 py-1.5 text-sm' 
      : 'px-2.5 py-1 text-xs';

  return (
    <span className={`
      inline-flex items-center justify-center
      ${sizeClasses}
      rounded-full font-medium
      border
      ${config.bgColor}
      ${config.color}
      ${config.borderColor}
      ${className}
    `}>
      {config.icon && <span className="mr-1">{config.icon}</span>}
      {config.label}
    </span>
  );
};

// Pre-styled badge variants for easy use
export const StatusBadge = ({ status, ...props }) => (
  <Badge type="status" status={status} {...props} />
);

export const ConditionBadge = ({ condition, ...props }) => (
  <Badge type="condition" condition={condition} {...props} />
);

export const OrderStatusBadge = ({ status, ...props }) => (
  <Badge type="orderStatus" status={status} {...props} />
);

export const ModerationBadge = ({ status, ...props }) => (
  <Badge type="moderation" status={status} {...props} />
);

export const CategoryBadge = ({ category, ...props }) => (
  <Badge type="category" category={category} {...props} />
);

export const BoostBadge = ({ status, ...props }) => (
  <Badge type="boost" status={status} {...props} />
);

export const PriceBadge = ({ negotiable, ...props }) => (
  <Badge type="price" status={negotiable ? 'negotiable' : 'fixed'} {...props} />
);

export const FeaturedBadge = (props) => (
  <Badge type="featured" {...props} />
);

export const UrgentBadge = (props) => (
  <Badge type="urgent" {...props} />
);

export const DiscountBadge = (props) => (
  <Badge type="discount" {...props} />
);

export default Badge;

// Example usage:
/*
// Status badges
<StatusBadge status="active" />          // Active
<StatusBadge status="sold" />            // Sold
<StatusBadge status="draft" />           // Draft

// Condition badges
<ConditionBadge condition="new" />       // New
<ConditionBadge condition="used" />      // Used
<ConditionBadge condition="refurbished" /> // Refurbished

// Order status badges
<OrderStatusBadge status="pending" />    // Pending
<OrderStatusBadge status="processing" /> // Processing
<OrderStatusBadge status="completed" />  // Completed

// Moderation badges
<ModerationBadge status="approved" />    // ✅ Approved (won't show)
<ModerationBadge status="pending" />     // ⏳ Pending Review
<ModerationBadge status="rejected" />    // ❌ Rejected

// Category badge
<CategoryBadge category="Electronics" /> // Electronics

// Custom sizes
<Badge type="status" status="active" size="small" />  // Small badge
<Badge type="status" status="active" size="medium" /> // Medium badge (default)
<Badge type="status" status="active" size="large" />  // Large badge

// With custom class
<Badge type="status" status="active" className="ml-2" />
*/